export const version = "abstract-signer/5.1.0";
